import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import i18n from 'i18n';
import getUsersISOLocale from '../i18n/getUsersISOLocale';
var defaultOptions = {
  weekday: 'short',
  month: 'long',
  day: 'numeric'
};
function getLocalisedDate(_ref) {
  var date = _ref.date,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? defaultOptions : _ref$options,
    _ref$fallbackVariant = _ref.fallbackVariant,
    fallbackVariant = _ref$fallbackVariant === void 0 ? 'null' : _ref$fallbackVariant,
    _ref$isInLocalTimezon = _ref.isInLocalTimezone,
    isInLocalTimezone = _ref$isInLocalTimezon === void 0 ? false : _ref$isInLocalTimezon;
  // If date is not available, return correct fallback
  if (!date && fallbackVariant === 'n-a') {
    return i18n.t('not_applicable');
  } else if (!date && fallbackVariant === 'hyphen') {
    return '-';
  } else if (!date) {
    return null;
  }

  // If date is in alread in local timezone, ensure no further conversion is done
  if (isInLocalTimezone) {
    // Check if date is a pure date or a datetime
    if (date.indexOf('T') !== -1) {
      // date.includes is not supported :(
      // If date includes a time, clean it
      var _date$split = date.split('T'),
        _date$split2 = _slicedToArray(_date$split, 2),
        pureDate = _date$split2[0],
        time = _date$split2[1];
      date = "".concat(pureDate, "T").concat(time.split('.')[0]);
    } else if (date.indexOf('T') === -1) {
      // If date does not includes a time, add time to it
      date = "".concat(date, "T00:00:00");
    }
  }
  var convertedDate = new Date(date);
  return new Intl.DateTimeFormat(getUsersISOLocale(), options).format(convertedDate);
}
export default getLocalisedDate;